import useSafeRouter from '../useSafeRouter/useSafeRouter';

const usePathname = () => {
  const { asPath } = useSafeRouter();
  return asPath;
};

export default usePathname;
